import { t } from "i18next";
import classNames from "classnames";
import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  IWebsiteBuilderElementDesignStyles,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";

export type TWebsiteBuilderButtonBorderStyle = "solid" | "transparent";

export interface IWebsiteBuilderButtonSettings {
  label: string;
  borderStyle: TWebsiteBuilderButtonBorderStyle;
  roundedCorners: boolean;
  link: string;
  color: string;
  backgroundColor: string;
  borderColor: string;
}

export interface IWebsiteBuilderButtonData extends IWebsiteBuilderElementDataBase {
  type: "button";
  settings: IWebsiteBuilderButtonSettings;
}

export interface IWebsiteBuilderButton extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderButtonData;
}

export function isWebsiteBuilderButton(node: TWebsiteBuilderElement): node is IWebsiteBuilderButton {
  return node?.element?.type === "button";
}

export function generateDefaultButton(): IWebsiteBuilderButton {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "button",
      position: { x: 0, y: 0 },
      dimensions: { width: 70, height: 35 },
      zIndex: null,
      settings: {
        label: t("Action"),
        borderStyle: "solid",
        roundedCorners: false,
        link: "",
        color: null,
        backgroundColor: null,
        borderColor: null,
      },
    },
  };
}

export function generateButtonDesignStyles(
  settings: IWebsiteBuilderButtonSettings,
): IWebsiteBuilderElementDesignStyles {
  return {
    className: classNames("website-builder-button", {
      "button-rounded-corners": settings.roundedCorners,
    }),
    style: {
      color: settings.color,
      backgroundColor: settings.backgroundColor,
      borderColor: settings.borderStyle === "transparent" ? "transparent" : settings.borderColor,
    },
  };
}
